export const ISODATETIME_FORMAT = new RegExp('[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}');
export const ISODATE_FORMAT = new RegExp('[0-9]{4}-[0-9]{2}-[0-9]{2}');
export const ISOTIME_FORMAT = new RegExp('[0-9]{2}:[0-9]{2}:[0-9]{2}');
export const ACCEPT_DATE_FORMAT = new RegExp('([0-9]){2}\\/([0-9]){2}\\/([0-9]){4}');
export const INPUT_MASK_DATE_FORMAT = new RegExp('([0-9]|[\\W_]){2}\\/([0-9]|[\\W_]){2}\\/([0-9]|[\\W_]){4}');
